import { render, staticRenderFns } from "./ActivityDashboard.vue?vue&type=template&id=b7db285c&"
import script from "./ActivityDashboard.vue?vue&type=script&lang=js&"
export * from "./ActivityDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports